import { render, staticRenderFns } from "./AiBuddyButtonRounded.vue?vue&type=template&id=f6c08c8a&scoped=true"
import script from "./AiBuddyButtonRounded.vue?vue&type=script&lang=js"
export * from "./AiBuddyButtonRounded.vue?vue&type=script&lang=js"
import style0 from "./AiBuddyButtonRounded.vue?vue&type=style&index=0&id=f6c08c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c08c8a",
  null
  
)

export default component.exports